"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
// Switched to React Icons setup
import { FaInstagram, FaLinkedinIn, FaFacebookF, FaSearch } from "react-icons/fa";
import styles from "./Footer.module.css";

export function Footer() {
  return (
    <footer className={styles.footerWrapper}>
      
      {/* Brand Identity Header */}
      <div className={styles.brandBlock}>
        <div className={styles.logoHeading}>
          <Image
            src="/quality-collection-logo.webp" // Place your logo in public/logo.png
            alt="Quality Collection Logo"
            width={180}
            height={60}
            className={styles.logoImage}
            priority
          />
        </div>
        <ul className={styles.subTagsRow}>
          <li className={styles.subTagItem}>Metal Artisanry</li>
          <li className={styles.subTagItem}>Global Trade & Exports</li>
          <li className={styles.subTagItem}>Bespoke Hardware</li>
        </ul>
      </div>

      <hr className={styles.divider} />

      {/* Navigation Directory */}
      <nav className={styles.navLinksRow} aria-label="Footer Hub Directory">
        <Link href="/" className={styles.navLink}>Home</Link>
        <Link href="/about-us" className={styles.navLink}>About Us</Link>
        <Link href="/catalogues" className={styles.navLink}>Catalogues</Link>
        <Link href="/products" className={styles.navLink}>Products</Link>
        <Link href="/contact" className={styles.navLink}>Contact us</Link>
      </nav>

      {/* Social Icons using react-icons */}
      <div className={styles.socialRow}>
        <a href="https://www.instagram.com/thequalityexports/?hl=en" target="_blank" rel="noopener noreferrer" className={styles.iconSquare} aria-label="Instagram">
          <FaInstagram size={16} />
        </a>
        <a href="https://www.linkedin.com/feed/" target="_blank" rel="noopener noreferrer" className={styles.iconSquare} aria-label="LinkedIn">
          <FaLinkedinIn size={16} />
        </a>
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className={styles.iconSquare} aria-label="Facebook">
          <FaFacebookF size={15} />
        </a>
        <a href="https://google.com" target="_blank" rel="noopener noreferrer" className={styles.iconSquare} aria-label="Search Profile">
          <FaSearch size={14} />
        </a>
      </div>

      {/* Huge Faint Watermark Text Effect */}
      <div className={styles.watermark}>
        QUALITY COLLECTION
      </div>

      {/* Center-Aligned Legal Links */}
      <div className={styles.bottomMetaArea}>
        <div className={styles.legalRow}>
          <Link href="/terms" className={styles.legalLink}>Terms & Conditions</Link>
          <span className={styles.legalPipe}>|</span>
          <Link href="/privacy" className={styles.legalLink}>Privacy Policy</Link>
          <span className={styles.legalPipe}>|</span>
          <Link href="/disclosures" className={styles.legalLink}>Disclosures</Link>
        </div>

        <span className={styles.copyright}>
          © 2026 QC Foundry. All Rights Reserved.
        </span>
      </div>

    </footer>
  );
}